import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import styles from "./PayOfflineModal.module.css";

const formatCurrency = (value) => {
  const num = Number(value) || 0;
  return `${num < 0 ? "-" : ""}₹${Math.abs(num).toLocaleString("en-IN")}`;
};

const PayOfflineModal = ({
  open,
  onClose,
  onConfirm,
  submitting = false,
  student = {},
  paymentMode = "Cash",
  amount = 0, // amount being paid now (from the "Amount paying now" input)
  totalDue = 0, // full outstanding balance, to compute what's left
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [open]);

  if (!open) return null;

  const payNow = Number(amount) || 0;
  // fall back to `amount` if the parent doesn't pass a separate total
  const outstanding = Number(totalDue) || payNow;

  // remaining balance = outstanding - what's being paid now (never negative)
  const balanceAfterPayment = Math.max(outstanding - payNow, 0);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !submitting) onClose?.();
  };

  // hand the paid amount back so the parent posts exactly what was typed
  const handleConfirm = () => {
    if (submitting) return;
    onConfirm?.(payNow);
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3 className={styles.title}>Confirm fee collection</h3>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            disabled={submitting}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>

        <div className={styles.amount}>{formatCurrency(payNow)}</div>

        <div className={styles.body}>
          <div className={styles.row}>
            <span className={styles.label}>Student</span>
            <span className={styles.value}>{student.name || "-"}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Admission ID</span>
            <span className={styles.value}>{student.admissionId || "-"}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Class</span>
            <span className={styles.value}>{student.classSection || "-"}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Payment mode</span>
            <span className={styles.value}>{paymentMode}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Balance after payment</span>
            <span className={styles.value}>
              {formatCurrency(balanceAfterPayment)}
            </span>
          </div>
        </div>

        <p className={styles.disclaimer}>
          Receipt will be generated and recorded in the fee ledger. This
          can&apos;t be undone except by a reversing entry.
        </p>

        <div className={styles.footer}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles.confirmButton}
            onClick={handleConfirm}
            disabled={submitting}
          >
            {submitting ? "Collecting..." : "Confirm & collect"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayOfflineModal;
